import React, { FC } from 'react';

import { Flex } from 'Src/components/layout/Flex';
import { HeaderMainNav } from 'Src/components/navigation/HeaderMainNav';
import { TabProvider } from 'Src/components/navigation/useTabs';
import { CheckCreateModal } from 'Src/feature/check-create/CheckCreateModal';
import { ChecksDefaultView } from 'Src/feature/checks/ChecksDefaultView';
import { ChecksPageProvider, useChecksPage } from 'Src/feature/checks/useChecksPage';
import { FormField } from 'Src/feature/form/FormField';
import { Page } from 'Src/feature/page/Page';
import { PageMain } from 'Src/feature/page/PageMain';
import { PageMainHeader } from 'Src/feature/page/PageMainHeader';
import { routeParamValue } from 'Src/routes/params';

import { ChecksFloorPlan } from './ChecksFloorPlan';
import { ChecksList } from './ChecksList';

const sectionId = 'ChecksPage';

const ChecksPage: FC = () => {
  const store = useChecksPage();

  return (
    <Page
      sectionId={sectionId}
      main={(
        <PageMain
          header={store.currentSelection === 'searchMode' ? undefined : (
            <PageMainHeader
              borderBottom
              start={(
                <>
                  <FormField
                    type="select"
                    size="xl"
                    variant="no-background"
                    padding="none"
                    options={store.section.options}
                    value={store.section.value}
                    onChange={(_event, values) => {
                      const [next] = values as [string];
                      store.section.onChange(next);
                    }}
                  />
                  <FormField
                    type="tab-select"
                    options={store.options}
                    size="sm"
                    value={store.currentSelection}
                    onChange={(o) => {
                      const selection = Array.isArray(o.values) ? o.values[0] : o.values;
                      store.setCurrentSelection(selection as Parameters<typeof store.setCurrentSelection>[0]);
                    }}
                  />
                </>
              )}
              end={<HeaderMainNav />}
            />
          )}
          main={(
            <Flex fullHeight>
              {(() => {
                switch(store.section.value) {
                  case routeParamValue.defaultView: return <ChecksDefaultView />;
                  case routeParamValue.checksList: return <ChecksList />;
                  case routeParamValue.checksFloorPlan: return <ChecksFloorPlan />;
                }
              })()}
            </Flex>
          )}
        />
      )}
    />
  );
};

// eslint-disable-next-line react/no-multi-comp
const CheckPageWithProvider: FC = () => (
  <ChecksPageProvider>
    <TabProvider>
      <ChecksPage />
      <CheckCreateModal />
    </TabProvider>
  </ChecksPageProvider>
);

// default export as this is a lazy loaded module
export default CheckPageWithProvider;
export { ChecksPage, sectionId };
